import { render, staticRenderFns } from "./CardSubheader.vue?vue&type=template&id=b07b5f86&scoped=true&"
import script from "./CardSubheader.vue?vue&type=script&lang=js&"
export * from "./CardSubheader.vue?vue&type=script&lang=js&"
import style0 from "./CardSubheader.vue?vue&type=style&index=0&id=b07b5f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07b5f86",
  null
  
)

export default component.exports